import {
    PermitDetailsTabActionTypes,
    UPDATE_PERMIT_ASSIGNEE,
    LOAD_PERMIT_SUBMITTER_SUCCESSFUL,
    UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL,
} from "./types";
import { User } from "../../models/User";
import { LocationLog } from "../../models/LocationLog";
import { PermitAssignment } from "../../models/PermitAssignment";

export function updatePermitAssignee(assignment: PermitAssignment): PermitDetailsTabActionTypes {
    return {
        type: UPDATE_PERMIT_ASSIGNEE,
        assignment,
    };
}

export function loadPermitSubmitterSuccessful(user: User): PermitDetailsTabActionTypes {
    return {
        type: LOAD_PERMIT_SUBMITTER_SUCCESSFUL,
        user,
    };
}

export function updatePermitLastAccessSuccessful(
    permitId: string,
    locationLog: LocationLog
): PermitDetailsTabActionTypes {
    return {
        type: UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL,
        locationLog,
        permitId,
    };
}
